import { asyncLoadRouter } from '@router/helper'

const telemetry = [
  {
    path: 'telemetry',
    component: asyncLoadRouter('machines/Telemetry'),
    meta: {
      breadcrumb: (i18n) => [
        {
          text: i18n.t('machine.telemetry.title'),
          to: { name: 'machines-telemetry' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'machines-telemetry',
        component: asyncLoadRouter('machines/telemetry/Show'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.show') }] },
      },
    ],
  },
]

export default telemetry
